<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SubscriptionBlockedScreen',
  computed: {
    ...mapGetters({
      blockedReason: 'subscription/blockedReason',
      gracePeriodEnd: 'subscription/gracePeriodEnd',
    }),
    formattedGracePeriod() {
      if (!this.gracePeriodEnd) return null;
      return new Date(this.gracePeriodEnd).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
  },
};
</script>

<template>
  <div class="subscription-blocked-screen">
    <div class="subscription-blocked-card">
      <div class="subscription-blocked-icon">
        <span class="i-lucide-lock" />
      </div>
      <h1 class="subscription-blocked-title">
        {{ $t('PIPELINE_PERMISSIONS.BLOCKED.TITLE') }}
      </h1>
      <p class="subscription-blocked-reason">
        {{ blockedReason || $t('PIPELINE_PERMISSIONS.BLOCKED.DEFAULT_REASON') }}
      </p>
      <p v-if="formattedGracePeriod" class="subscription-blocked-deadline">
        {{ $t('PIPELINE_PERMISSIONS.BLOCKED.DEADLINE_PREFIX') }}
        <strong>{{ formattedGracePeriod }}</strong>
      </p>
      <div class="subscription-blocked-actions">
        <a
          href="https://branorai.com/contato"
          target="_blank"
          rel="noopener noreferrer"
          class="subscription-blocked-btn"
        >
          {{ $t('PIPELINE_PERMISSIONS.BLOCKED.SETTLE_PAYMENT') }}
        </a>
        <p class="subscription-blocked-support">
          {{ $t('PIPELINE_PERMISSIONS.BLOCKED.SUPPORT_HINT') }}
          <a href="mailto:suporte@branorai.com">{{
            $t('PIPELINE_PERMISSIONS.BLOCKED.SUPPORT_EMAIL')
          }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.subscription-blocked-screen {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(17, 24, 39, 0.97);
}

.subscription-blocked-card {
  background: #fff;
  border-radius: 1rem;
  padding: 2.5rem 2rem;
  max-width: 28rem;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

.subscription-blocked-icon {
  font-size: 3rem;
  color: #ef4444;
  margin-bottom: 1rem;
}

.subscription-blocked-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.75rem;
}

.subscription-blocked-reason {
  font-size: 0.9375rem;
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 0.75rem;
}

.subscription-blocked-deadline {
  font-size: 0.875rem;
  color: #ef4444;
  margin-bottom: 1.5rem;
}

.subscription-blocked-btn {
  display: inline-block;
  background: #2563eb;
  color: #fff;
  font-weight: 600;
  padding: 0.75rem 2rem;
  border-radius: 0.625rem;
  text-decoration: none;
  transition: background 0.15s;
}

.subscription-blocked-btn:hover {
  background: #1d4ed8;
}

.subscription-blocked-support {
  font-size: 0.8125rem;
  color: #9ca3af;
  margin-top: 1rem;
}

.subscription-blocked-support a {
  color: #6b7280;
}
</style>
